import { MenuItemStyled } from '@molecules/Filters/styles';
import { SelectChangeEvent, SelectProps, SxProps } from '@mui/material';
import { StyledInputLabel, StyledSelect, StyledWrapperSelectBox } from '../styles';
import React, { ReactNode } from 'react';
import { FilterCloseWrap } from '@molecules/Filters/FilterCloseWrap';

interface ICustomSelect<T> extends SelectProps {
  title: string;
  handleOnChange: (event: SelectChangeEvent<unknown>) => void;
  listData?: T;
  placeholder?: string;
  customSxForWrapper?: SxProps;
  children?: ReactNode;
  handleClose?: () => void;
  customSxForSelect?: SxProps;
}

const CustomSelect = <T extends Record<string, any>>({
  title,
  listData,
  placeholder = 'Select option',
  customSxForWrapper,
  handleOnChange,
  children,
  handleClose,
  customSxForSelect,
  ...props
}: ICustomSelect<T>) => {
  const handleRenderSelect = () => {
    return (
      <StyledSelect
        sx={{
          '&.Mui-disabled': {
            backgroundColor: '#0000001F',
          },
          ...customSxForSelect,
        }}
        placeholder={placeholder}
        onChange={handleOnChange}
        {...props}
      >
        {children
          ? children
          : Object.entries(listData || {}).map(([, key]) => (
              <MenuItemStyled key={key} value={key}>
                {key}
              </MenuItemStyled>
            ))}
      </StyledSelect>
    );
  };

  return (
    <>
      {handleClose ? (
        <FilterCloseWrap label={title} onClose={handleClose}>
          {handleRenderSelect()}
        </FilterCloseWrap>
      ) : (
        <StyledWrapperSelectBox sx={{ marginRight: '12px', ...customSxForWrapper }}>
          <StyledInputLabel>{title}</StyledInputLabel>
          {handleRenderSelect()}
        </StyledWrapperSelectBox>
      )}
    </>
  );
};

export default React.memo(CustomSelect);
